(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REB = window.REB || { currency: 'INR', routes: {} };

  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function money(cents) {
    var v = cents / 100;
    if (REB.currency === 'INR') {
      return 'Rs. ' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    }
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: REB.currency }).format(v); }
    catch (e) { return v.toFixed(2) + ' ' + REB.currency; }
  }
  function toast(t) {
    var el = $('#toast'); if (!el) return;
    el.textContent = t; el.classList.add('on');
    clearTimeout(toast.t); toast.t = setTimeout(function () { el.classList.remove('on'); }, 1800);
  }

  /* ---------- overlays ---------- */
  var scrim = $('#scrim'), drawer = $('#drawer'), sm = $('#sm');
  function closeAll() {
    if (drawer) { drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); }
    if (sm) sm.classList.remove('on');
    if (scrim) scrim.classList.remove('on');
  }
  function openDrawer() {
    renderCart().then(function () {
      drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); scrim.classList.add('on');
      var c = $('#closeCart'); if (c) c.focus();
    });
  }
  function openSearch() {
    sm.classList.add('on'); scrim.classList.add('on');
    var q = $('#q'); if (q) { q.value = ''; q.focus(); }
    var r = $('#res'); if (r) r.innerHTML = '';
  }

  /* ---------- cart ---------- */
  function getCart() { return fetch(REB.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); });
  }
  function renderCart() {
    return getCart().then(function (cart) {
      setCount(cart.item_count);
      var body = $('#cartBody'), foot = $('#cartFoot');
      if (!body) return cart;
      if (!cart.items.length) {
        body.innerHTML = '<div style="padding:36px 0"><h3 style="font-size:40px;margin-bottom:10px">Your cart is empty</h3><p style="color:var(--muted);margin:0 0 20px">Pick a fit and a size to add it here.</p><a class="btn red" href="/collections/all">Continue shopping</a></div>';
        foot.innerHTML = '';
        return cart;
      }
      body.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="' + esc(it.title) + '" loading="lazy" width="72" height="90">' : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' &middot; ' : '';
        return '<div class="line"><div class="t">' + img + '</div><div><h4><a href="' + esc(it.url) + '" style="text-decoration:none">' + esc(it.product_title) + '</a></h4>' +
          '<small>' + variant + money(it.final_price) + '</small>' +
          '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="rm" data-line="' + (i + 1) + '" data-qty="0">Remove</button></div>' +
          '<b style="font-variant-numeric:tabular-nums">' + money(it.final_line_price) + '</b></div>';
      }).join('');
      var discount = cart.total_discount > 0 ? '<div class="sum disc"><span>Discounts</span><span>&minus; ' + money(cart.total_discount) + '</span></div>' : '';
      foot.innerHTML = '<div class="sum"><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>' + discount +
        '<div class="sum total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' +
        '<p class="note" style="margin:0">Delivery and discounts are calculated at checkout.</p>' +
        '<form action="' + esc(REB.routes.cart) + '" method="post"><button class="btn red block" type="submit" name="checkout">Checkout</button></form>' +
        '<a class="btn block" href="' + esc(REB.routes.cart) + '">View cart</a>';
      return cart;
    });
  }
  function changeLine(line, qty) {
    return fetch(REB.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +line, quantity: +qty })
    }).then(function () { return renderCart(); });
  }

  /* ---------- product form ---------- */
  function initProduct() {
    var form = $('#product-form'); if (!form) return;
    var data = JSON.parse($('#ProductJSON').textContent);
    var idInput = $('input[name="id"]', form), btn = $('[data-add]', form);
    var priceEl = $('#pPrice'), err = $('#pErr');
    function selected() {
      return $$('.opt', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function find(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function showMedia(id) {
      var b = $('.thumbs button[data-media="' + id + '"]'); if (b) b.click();
    }
    function update() {
      var v = find(selected());
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      var off = v.compare_at_price && v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
      priceEl.innerHTML = '<div class="price"><b>' + money(v.price) + '</b>' + (off ? '<s>' + money(v.compare_at_price) + '</s><span class="off">' + off + '% OFF</span>' : '') + '</div>';
      if (v.featured_media) showMedia(v.featured_media.id);
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
      if (err) err.textContent = '';
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(); });
    $$('.qty [data-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = $('input[name="quantity"]', form); q.value = Math.max(1, (+q.value || 1) + (+b.dataset.step));
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      fetch(REB.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { if (err) err.textContent = res.j.description || res.j.message || 'Could not add this to your cart. Try again.'; return; }
          toast('Added to cart'); openDrawer();
        })
        .catch(function () { btn.disabled = false; if (err) err.textContent = 'Could not add this to your cart. Check your connection and try again.'; });
    });
    update();
  }

  /* ---------- gallery ---------- */
  function initGallery() {
    var main = $('.gal .main img'); if (!main) return;
    $$('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.full; main.srcset = ''; main.alt = b.dataset.alt || '';
        $$('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- predictive search ---------- */
  var timer;
  function initSearch() {
    var q = $('#q'), res = $('#res'); if (!q) return;
    q.addEventListener('input', function () {
      clearTimeout(timer);
      var term = q.value.trim();
      if (term.length < 2) { res.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(REB.routes.suggest + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { res.innerHTML = '<p class="empty" style="padding:16px 0">No product matches that. Try tee, hoodie or joggers.</p>'; return; }
            res.innerHTML = items.map(function (p) {
              return '<a href="' + esc(p.url) + '"><span class="rl">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="44" height="55">' : '') + '<span>' + esc(p.title) + '</span></span><b>' + esc(p.price ? (REB.currency === 'INR' ? 'Rs. ' + Number(p.price).toLocaleString('en-IN') : p.price) : '') + '</b></a>';
            }).join('');
          }).catch(function () { res.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('button,a,[data-open-cart],[data-open-search]'); if (!t) return;
    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); openDrawer(); return; }
    if (t.hasAttribute('data-open-search')) { e.preventDefault(); openSearch(); return; }
    if (t.id === 'closeCart' || t.id === 'closeSearch') { closeAll(); return; }
    if (t.dataset.line !== undefined && t.dataset.qty !== undefined) { changeLine(t.dataset.line, t.dataset.qty); return; }
    if (t.id === 'burger') {
      var nav = $('#nav'); var o = nav.classList.toggle('open'); t.setAttribute('aria-expanded', o);
    }
  });
  if (scrim) scrim.addEventListener('click', closeAll);
  if (sm) sm.addEventListener('click', function (e) { if (e.target === sm) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('DOMContentLoaded', function () {
    initProduct(); initGallery(); initSearch();
    getCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
  });
})();
